import { ButtonHTMLAttributes, DetailedHTMLProps } from "react"

interface Props extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
	variant?: "primary" | "secondary"
	isLoading?: boolean
}

export default function Button(props: Props) {
	const { onClick, children, className, isLoading, disabled, ...rest } = props;
	const variant = props.variant || "primary";

	return <button
		onClick={onClick}
		type="button"
		className={[
			"focus:ring-4 rounded-xl text-center flex items-center justify-center",
			variant === "primary" ? disabled ? "text-white bg-gray-01" : "text-white bg-blue-base  hover:bg-blue-700" : disabled ? "text-gray-base bg-white border border-gray-01" : "text-black-base bg-white border border-gray-01 hover:bg-gray-01",
			className,
		].join(" ")}
		disabled={disabled}
		{...rest}
	>
		{isLoading ? <div className={["pulse-spinner", variant === "primary" ? "bg-white" : "bg-gray-base"].join(" ")} /> : children}
	</button>
}